import RecordBase from './../tools/RecordBase';

class BusTipo extends RecordBase {

  constructor () {
    super();
    this.state.cls = 'bustipos';
    this.title = 'Bus Tipo'
  }

}

export default BusTipo;
